export default {
    props: {
        api_route: {
            required: true,
            type:     String
        }
    },

    data() {
        return {
            submitting: false
        };
    },

    methods: {
        addItem() {
            if (this.submitting)
                return;

            let data = this.prepareNewItemData();

            if (Object.keys(data).length === 0) {
                return;
            }

            this.$set(this, 'submitting', true);

            axios.post(`${this.api_route}`, data)
                .then(response => {
                    this.$toast.success({
                        title:   'USPEH!',
                        message: response.data.message
                    });

                    this.$root.closeModal();
                    this.$root.closeNestedModal();

                    this.resetNewItem();

                    this.$events.fire('refreshTableData');

                    this.$set(this, 'submitting', false);
                })
                .catch(error => {
                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    }

                    this.$root.closeModal();

                    this.$events.fire('refreshTableData');

                    this.$set(this, 'submitting', false);
                });
        },
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/NewItem.js